export const COPYRIGHT_TEXT = "Copyright 2022 Living Rewards. All Rights Reserved.";
export const CONTACT_US = "Contact us";
export const SHOP_ONLINE = "Shop online";
export const TERMS_AND_CONDITIONS = "Terms & conditions";
export const FAQS = "About us / FAQs";
export const PRIVACY_POLICY_TEXT = "Privacy Policy";